import {usePath} from '../contexts/PathContext'
import {useRefInfo} from '../contexts/RefInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {useLatestCommit} from '@github-ui/use-latest-commit'
import {AlertIcon} from '@primer/octicons-react'
import {Flash} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'

import styles from './SpoofedCommitWarning.module.css'
import {useIsDataRouterEnabled} from '@github-ui/react-core/future/use-is-data-router-enabled'
import {useLatestCommitContext} from '../contexts/LatestCommitContext'

export function SpoofedCommitWarning() {
  const isDataRouter = useIsDataRouterEnabled()

  return isDataRouter ? <SpoofedCommitWarningDataRouter /> : <SpoofedCommitWarningInternal />
}

function SpoofedCommitWarningDataRouter() {
  const {latestCommit} = useLatestCommitContext()
  const isSpoofed = latestCommit?.isSpoofed ?? false

  if (!isSpoofed) {
    return null
  }

  return <SpoofedCommitWarningBanner className={styles.SpoofedCommitWarningBanner} />
}

function SpoofedCommitWarningInternal() {
  if (!useLatestCommitIsSpoofed()) {
    return null
  }

  return <SpoofedCommitWarningBanner className={styles.SpoofedCommitWarningBanner} />
}

export function SpoofedCommitWarningBanner({className}: {className?: string}) {
  return (
    <Flash variant="warning" className={className} data-testid="spoofed-commit-warning-banner">
      <Octicon icon={AlertIcon} />
      <span>
        This commit does not belong to any branch on this repository, and may belong to a fork outside of the
        repository.
      </span>
    </Flash>
  )
}

export function useLatestCommitIsSpoofed() {
  const repo = useCurrentRepository()
  const path = usePath()
  const refInfo = useRefInfo()
  const [latestCommit] = useLatestCommit(repo.ownerLogin, repo.name, refInfo.name, path)
  return latestCommit?.isSpoofed ?? false
}
